import { Box, Checkbox, Typography } from '@percent/lemonade'

import type { OpportunityFormNotificationsEnabledCheckboxProps } from './opportunity-form-notifications-enabled-checkbox.types'
import styles from './opportunity-form-notifications-enabled-checkbox.module.scss'

export function OpportunityFormNotificationsEnabledCheckbox({
  value,
  onChange,

  label,
}: Readonly<OpportunityFormNotificationsEnabledCheckboxProps>) {
  return (
    <Checkbox
      name="notificationsEnabled"
      value={value ? 'true' : undefined}
      active={value}
      onChange={(e) => onChange(e.currentTarget.checked)}
      label={
        <Box>
          <Typography className={styles.TimeTrackingLabel}>{label}</Typography>
        </Box>
      }
      variant="default"
    />
  )
}
